namespace SPA {
	export namespace Realtor {

		export class Immo24Builder
			extends ObjectDataBuilder<Wollmilch.Realtor.Object> {

			private m_Parent: JQuery | ui.base.BaseHTMLElement | null;
			private m_Images: string[];

			public constructor(data: Wollmilch.Realtor.Object, images: [] = []) {
				super(data);

				this.m_Parent = null;
				this.m_Images = images; // Data from Page.ts
			}

			public rebuild(root: ui.base.BaseHTMLElement | JQuery, navigation?: Navigation): ExposeBuilder {
				this.m_Parent = root;
				const basicBox = new ui.Box.Box();

				basicBox.clearTitle();
				basicBox.addTitle('ImmoScout24 Exposé erstellen');
				// basicBox.rebuild(root.empty());
				basicBox.rebuild(root);

				// Iterate over all images and fetch the neccessary ones
				let imageMain = '';
				let imageLage = '';
				let imageDesc = '';
				let imageAusstattung = '';
				let imageOther = '';
				let grundriss1 = '';
				let grundriss2 = '';
				let grundriss3 = '';
				let grundriss4 = '';
				for (const image of this.m_Images.files) {
					if (image.id === 0) {
						continue;
					}
					const path = app.getRemotePath() + this.m_Data.ObjectNumber + '/' + image.default_id + '/';

					switch (image.default_id) {
						case 27:
							imageMain = path + image.filename;
							break;
						case 28:
							imageLage = path + image.filename;
							break;
						case 29:
							imageDesc = path + image.filename;
							break;
						case 30:
							imageAusstattung = path + image.filename;
							break;
						case 31:
							grundriss1 = path + image.filename;
							break;
						case 32:
							grundriss2 = path + image.filename;
							break;
						case 33:
							grundriss3 = path + image.filename;
							break;
						case 34:
							grundriss4 = path + image.filename;
							break;
						case 35:
							imageOther = path + image.filename;
							break;
					}
				}

				let htmlImp = '';
				let idx = 0;
				for (const image of this.m_Images.files) {
					if (image.group_id !== 5 || image.id === 0) {
						continue;
					}

					const filename = app.getRemotePath() + this.m_Data.ObjectNumber + '/' + image.default_id + '/' + image.filename;

					htmlImp +=
						'<div class="form-group col-sm-4">' +
						'<div class="image-text">' +
						'<div class="input-group">' +
						'<label class="input-group-addon">Bildtext</label>' +
						'<input type="text" class="form-control" name="expose.impression[' + idx + '][text]" value="' + image.title + '" placeholder="Text zum Bild">' +
						// '<input type="text" class="form-control" name="expose.impression[' + idx + '][text]" value="" placeholder="Text zum Bild">' +
						'</div>' +
						'<input type="hidden" name="expose.impression[' + idx + '][image]" value="' + filename + '" />' +
						'<img alt="Bildvorschau" src="' + filename + '"/>' +
						'</div>' +
						'</div>';

					idx++;
					if ((idx + 1) % 3 === 0) {
						htmlImp += '<div class="clearfix"></div>';
					}
				}

				const html = `
					<form id="expose-form" class="c2" action="create_expose.php">
					<fieldset class="form-horizontal">
						<legend>Deckblatt</legend>
					    <div class="col-sm-8">
							<div class="form-group">
								<label class="control-label col-sm-3">Slogan</label>
								<div class="col-sm-9">
									<input class="form-control" type="text" name="expose.slogan" value="${this.m_Data.Data.general.title}" />
								</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3">Adresse</label>
								<div class="col-sm-9">
									<input class="form-control" type="text" name="expose.address" value="${this.m_Data.Address.display}" />
								</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3">Objektnummer</label>
								<div class="col-sm-9">
									<input class="form-control" type="text" name="expose.oid" value="${this.m_Data.ObjectNumber}" />
								</div>
							</div>
						</div>
						<div class="col-sm-4">
							<label>Hauptbild</label>
							<input type="hidden" name="expose.image[main]" value="${imageMain}" />
							<img src="${imageMain}" />
						</div>
					</fieldset>` +
					`<div class="row">
					<fieldset class="col-sm-5 form-horizontal">
					  <legend>Eckdaten</legend>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Objektart</label>
					    <div class="col-sm-9">
					       Haus
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Objekttyp</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.housetype" value="${SPA.types.Object.Type[this.m_Data.Data.common.type.type]}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Nutzungsart</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.usage" value="Wohnen" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Vermarktungsart</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.marketing" value="Verkauf" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Kaufpreis</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.price" value="${this.m_Data.Data.general.price.value} ${this.m_Data.Data.general.price.currency}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Außen-Provision</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.commission" value="${this.m_Data.Data.general.fee.interior.value}" />
					    </div>
					  </div>
					</fieldset>
					<fieldset class="col-sm-5 col-sm-offset-1 form-horizontal">
					  <legend>Ausstattung</legend>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Wohnfläche</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.wf" value="${this.m_Data.Data.details.living_area.value}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Nutzfläche</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.nf" value="${this.m_Data.AdvData.nf || ''}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Grundstücksgröße</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.plot_size" value="${this.m_Data.Data.property.area.building + this.m_Data.Data.property.area.garden}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Anzahl Zimmer</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.rooms" value="${this.m_Data.AdvData.rooms || ''}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Anzahl Badezimmer</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.bath_rooms" value="${this.m_Data.AdvData.bathroom_count || ''}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Befeuerung</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.light" value="" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Heizungsart</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.firing" value="Zentralheizung" />
					    </div>
					  </div>
					</fieldset>
					</div>
					<div class="row">
					<fieldset class="col-sm-5 form-horizontal">
					  <legend>Daten zum Energieausweis</legend>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Baujahr</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.bj" value="${this.m_Data.Data.details.object.construction_year}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Zustand</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.status" value="${this.m_Data.Data.details.object.usability}" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Energieausweis</label>
					    <div class="col-sm-9">
					    <select class="form-control" name="expose.energy_cert">
					    	<option value="" selected> --- Bitte wählen ---</option>
					    	<option value="consumptions">Verbrauchsausweis</option>
					    	<option value="needs">Bedarfsausweis</option>
						</select>
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">Endenergiebedarf</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.energy_con" value="" />
					    </div>
					  </div>
					  <div class="form-group">
					    <label class="control-label col-sm-3">wesentlicher Energieträger</label>
					    <div class="col-sm-9">
					      <input class="form-control" type="text" name="expose.energy_main" value="" />
					    </div>
					  </div>
					</fieldset>
					</div>` +
					'<fieldset class="expose-freetext">' +
					'<legend>Freitextfelder</legend>' +
					'<div class="row">' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Lage</label>' +
					'<textarea class="form-control" rows="14" name="expose.location">' + (this.m_Data.AdvData.location || '') + '</textarea>' +
					'</div>' +
					'<div class="form-group col-sm-6"">' +
					'<label class="control-label col-sm-12">Kartenausschnitt</label>' +
					'<div class="col-sm-9">' +
					'<input type="hidden" name="expose.image[location]" value="' + imageLage + '" />' +
					'<img alt="Google | OSM | Mapbox" src="' + imageLage + '"/>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'<div class="row">' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Beschreibung</label>' +
					'<textarea class="form-control" rows="14" name="expose.description">' + (this.m_Data.AdvData.description || '') + '</textarea>' +
					'</div>' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Bild zur Beschreibung</label>' +
					'<div class="col-sm-9">' +
					'<input type="hidden" name="expose.image[description]" value="' + imageDesc + '" />' +
					'<img alt="Bild" src="' + imageDesc + '"/>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'<div class="row">' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Ausstattung</label>' +
					'<textarea class="form-control" rows="14" name="expose.equipment">' + (this.m_Data.AdvData.equipment || '') + '</textarea>' +
					'</div>' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Bild zur Ausstattung</label>' +
					'<div class="col-sm-9">' +
					'<input type="hidden" name="expose.image[equipment]" value="' + imageAusstattung + '" />' +
					'<img alt="Bild" src="' + imageAusstattung + '"/>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'<div class="row">' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Sonstige Angaben</label>' +
					'<textarea class="form-control" rows="14" name="expose.othertext">' + (this.m_Data.AdvData.others || '') + '</textarea>' +
					'</div>' +
					'<div class="form-group col-sm-6">' +
					'<label class="control-label col-sm-12">Bild zu Sonstige Angaben</label>' +
					'<div class="col-sm-9">' +
					'<input type="hidden" name="expose.image[other]" value="' + imageOther + '" />' +
					'<img alt="Bild" src="' + imageOther + '"/>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'</fieldset>' +
					'<fieldset>' +
					'<legend>Grundrisse</legend>' +
					'<div class="form-group col-sm-3">' +
					'<div class="image-text">' +
					'<div class="input-group">' +
					'<label class="input-group-addon">Bildtext</label>' +
					'<input type="text" class="form-control" name="expose.layout[0][text]" value="" placeholder="individueller Text">' +
					'</div>' +
					'<input type="hidden" name="expose.layout[0][image]" value="' + grundriss1 + '" />' +
					'<img alt="Bildvorschau" src="' + grundriss1 + '">' +
					'</div>' +
					'</div>' +
					'<div class="form-group col-sm-3">' +
					'<div class="image-text">' +
					'<div class="input-group">' +
					'<label class="input-group-addon">Bildtext</label>' +
					'<input class="form-control" type="text" name="expose.layout[1][text]" value="" placeholder="individueller Text">' +
					'</div>' +
					'<input type="hidden" name="expose.layout[1][image]" value="' + grundriss2 + '" />' +
					'<img alt="Bildvorschau" src="' + grundriss2 + '">' +
					'</div>' +
					'</div>' +
					'<div class="form-group col-sm-3">' +
					'<div class="image-text">' +
					'<div class="input-group">' +
					'<label class="input-group-addon">Bildtext</label>' +
					'<input class="form-control" type="text" name="expose.layout[2][text]" value="" placeholder="individueller Text">' +
					'</div>' +
					'<input type="hidden" name="expose.layout[2][image]" value="' + grundriss3 + '" />' +
					'<img alt="Bildvorschau" src="' + grundriss3 + '">' +
					'</div>' +
					'</div>' +
					'<div class="form-group col-sm-3">' +
					'<div class="image-text">' +
					'<div class="input-group">' +
					'<label class="input-group-addon">Bildtext</label>' +
					'<input class="form-control" type="text" name="expose.layout[3][text]" value="" placeholder="individueller Text">' +
					'</div>' +
					'<input type="hidden" name="expose.layout[3][image]" value="' + grundriss4 + '" />' +
					'<img alt="Bildvorschau" src="' + grundriss4 + '">' +
					'</div>' +
					'</div>' +
					'</fieldset>' +
					'<fieldset>' +
					'<legend>Impressionen</legend>' +
					htmlImp +
					// '<div class="row">' +
					// 	'<div class="col-sm-12">' +
					// 		'<button type="button" id="expose_add_impression" onclick="alert(\'Operation erfolgreich - Patient tot!\');">Bild hinzufügen</button>' +
					// 	'</div>' +
					// '</div>' +
					'</fieldset>' +
					'</form>';

				basicBox.append($(html));

				const addbtn = new ui.base.BaseHTMLElement<HTMLButtonElement>('button');
				addbtn.text('Exposé erstellen und anzeigen');
				addbtn.addClass('btn btn-lg btn-danger')
					.css({'margin-left': '1em'})
					.on(
						{
							click: () => this.buildExposePdf()
						}
					);

				basicBox.append(addbtn.Root());

				return this;
			}

			private buildUploadForm(ec: Wollmilch.Realtor.EnergyCertificate): void {
				const FileUpload = ui.$$.div();

				// @ts-ignore
				const galleryUploader = new qq.FineUploader(
					{
						element: FileUpload[0],
						template: 'qq-template-gallery',
						multiple: false,
						validation:
							{
								allowedExtensions: ['pdf']
							},
						autoUpload: false,
						emptyError: 'Aux.ERROR.file_empty',
						noFilesError: 'Aux.ERROR.no_files',
						request:
							{
								customHeaders:
									{
										'GSDWollmilch-API-Key': 'API-KEY',
										'GSDWollmilch-API-AuthToken': app.getAuthenticationManager().getAuthToken()
									},
								forceMultipart: true,
								method: 'PUT',
								paramsInBody: true,
								endpoint: (Wollmilch.useHTTPS ? "https" : "http") + "://" + Wollmilch.URL + 'api/v1/artifact/blob/' + ec.Artifact().ID()
							},
						cors:
							{
								// all requests are expected to be cross-domain requests
								expected: true,

								// if you want cookies to be sent along with the request
								sendCredentials: true
							}
					}
				);

				const modal: ui.dialog.Modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.set_energycertificate_file'))],
						body: [FileUpload],
						foot: [
							ui.$$.button().text(app.getMessage('Aux.SAVE_BTN')).addClass('btn btn-success').on(
								'click', () => {
									try {
										galleryUploader.uploadStoredFiles();
									} catch (nofileserror) {
										app.addNotify(
											{
												title: ['FILE_UPLOAD'],
												body: ['ERROR.NO_FILES_SELECTED_TO_UPLOAD'],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									modal.Hide();

									if (this.m_Parent) {
										this.rebuild(this.m_Parent);
									}
								}
							),
							ui.$$.button().text(app.getMessage('Aux.ABORT_BTN')).addClass('btn btn-danger').on(
								'click', () => modal.Hide()
							)
						]
					}
				);
			}

			private buildExposePdf(): void {
				$.ajax({
					url: '/Backend/expose.php',
					data: $('#expose-form').serialize(),
					method: 'POST',
					dataType: 'json',
					success: (res) => {
						if (res.file) {
							const link = document.createElement("a");
							link.setAttribute('download', '');
							link.href = res.file;
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						}
					}
				});
			}

			private buildECForm(ec?: Wollmilch.Realtor.EnergyCertificate): void {
				let modal: ui.dialog.Modal;

				const formCallback = ec ?
					(action: string, method: string, params: Wollmilch.Realtor.EnergyCertificateObject) => {
						ec.edit(
							params.Data,
							(response: Wollmilch.ResponseObject, ec: Wollmilch.Realtor.EnergyCertificate) => {
								if (!response.success) {
									app.addNotify(
										{
											title: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.new_additional_energycertificate'))],
											body: ['Energieausweis konnte nicht bearbeitet werden.'],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								if (this.m_Parent) {
									this.rebuild(this.m_Parent);
								}

								modal.Hide();
							}
						);
					} :
					(action: string, method: string, params: Wollmilch.Realtor.EnergyCertificateObject) => {
						Wollmilch.Realtor.EnergyCertificate.create(
							params.ObjectNumber,
							params.KeyDate,
							params.Data,
							(response: Wollmilch.ResponseObject, ec?: Wollmilch.Realtor.EnergyCertificate) => {
								if (!ec) {
									app.addNotify(
										{
											title: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.new_additional_energycertificate'))],
											body: ['Energieausweis konnte nicht erstellt werden.'],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								if (this.m_Parent) {
									this.rebuild(this.m_Parent);
								}

								modal.Hide();
							}
						);
					};

				const form = new ui.Form.Form(
					// @ts-ignore
					{
						action: '',
						method: 'POST',
						notSwitchable: true,
						static: false,
						// @ts-ignore
						submit: formCallback
					}
				);

				const form_parent = ui.$$.div();

				form.Initialize();

				form.rebuild(form_parent);

				modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.' + (ec ? 'edit_energycertificate' : 'new_additional_energycertificate')))],
						body: [form_parent],
						foot: [
							$(form.Buttons.submit.getElement()).text(app.getMessage(ec ? 'Aux.EDIT_BTN' : 'Aux.SAVE_BTN')),
							$(form.Buttons.cancel.getElement()).on('click', () => modal.Hide()).text(app.getMessage('Aux.ABORT_BTN'))
						]
					}
				);

				const addInput = (input: ui.Form.BasicInputField, baseclass: string[]) => {
					form.Input(input);
					input.Base().addClass(baseclass.join(' '));
				};

				form.append(
					ui.$$.div().addClass('form-group formless').append(
						ui.$$.p().addClass('form-required text-danger small-caps').text(app.getMessage('Aux.REQUIRED_INPUTS'))
					)
				);

				addInput(new ui.Form.HiddenTextInput(this.m_Data.ObjectNumber, 'ObjectNumber'), []);

				const keydate = new ui.Form.DateInput(
					ec ? ec.KeyDate() : new Date(), 'd.m.Y', {
						name: 'KeyDate',
						required: true,
						control: true,
						readonly: ec ? true : false
					}
				).rebuild(
					ui.$$.div().addClass('row').appendTo(form.Root())
						.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Stichtag' + '*'))
				);
				if (!ec) {
					addInput(keydate, ['col-xs-12', 'col-sm-8']);
				} else {
					keydate.Base().addClass(['col-xs-12', 'col-sm-8'].join(' '));
				}

				addInput(
					new ui.Form.RadioGroup(
						{
							value: ec ? ec.Type() : null,
							inline: 2,
							required: true,
							name: 'Data.type',
							radioButtons:
								[
									{
										value: 'consumptions',
										title: 'Verbrauchsausweis',
									},
									{
										value: 'needs',
										title: 'Bedarfsausweis'
									}
								]
						}
					).rebuild(
						ui.$$.div().addClass('row').appendTo(form.Root())
							.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Art des Ausweis\'' + '*'))
					),
					['col-xs-12', 'col-sm-8']
				);

				addInput(
					new ui.Form.LabelledNumberSlider(
						ec ? ec.OverallEfficiency() || -1 : -1,
						{
							min: 0,
							max: 800,
							step: 1,
							sentinal: 'Keine Angabe',
							name: 'Data.overall-efficiency',
							control: true
						},
						(n: number) => n + ' kWh/(m²*a)'
					).rebuild(
						ui.$$.div().addClass('row').appendTo(form.Root())
							.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Endenergiebedarf' + '*'))
					),
					['col-xs-12 col-sm-8']
				);

				addInput(
					new ui.Form.LabelledNumberSlider(
						ec ? ec.PrimaryConsumption() || -1 : -1,
						{
							min: 0,
							max: 800,
							step: 1,
							sentinal: 'Keine Angabe',
							name: 'Data.primary-consumption',
							control: true
						},
						(n: number) => n + ' kWh/(m²*a)'
					).rebuild(
						ui.$$.div().addClass('row').appendTo(form.Root())
							.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Primärenergiebedarf' + '*'))
					),
					['col-xs-12 col-sm-8']
				);

				if (ec) {

				}
			}

			private downloadFile(data: Wollmilch.ArtifactDownload) {
				const srcStr = 'data:' + data.MimeType + ';' + (data.Base64 ? 'base64,' : '');
				const element = document.createElement('a');
				element.setAttribute('href', srcStr + data.Blob);
				/* TODO sobald in der DB der Dateiname des Artefaktes mitgespeichert wird, diesen verwenden */
				element.setAttribute('download', 'downloadfile.bin' /* TODO data.Filename*/);

				element.style.display = 'none';
				document.body.appendChild(element);

				element.click();

				document.body.removeChild(element);
			}

			private loadBlob(att: Wollmilch.Realtor.EnergyCertificateObject, onsuccess: (data: Wollmilch.ArtifactDownload) => void) {
				new Wollmilch.AJAX(
					{
						url: 'artifact/download/' + att.Artifact.ID,
						method: 'GET',
						on:
							{
								success: (text: string) => {
									const obj = Wollmilch.jsonize(text);

									if (!obj || obj.success === false) {
										return;
									}

									onsuccess(obj.data);
								}
							}
					}
				).send();
			}

		}

	}
}
